'use client'

import React, { createContext, useContext, useState } from 'react'

import { User } from '@/payload-types'
import { signOutAction } from '@/app/(frontend)/actions'
import { useRouter } from 'next/navigation'

export interface UserContextType {
  user: User | null
  signOut: () => Promise<void>
  signIn: (email: string, password: string) => Promise<User | null>
}

const initialContext: UserContextType = {
  user: null,
  signOut: () => Promise.resolve(),
  signIn: (email: string, password: string) => Promise.resolve(null),
}

const UserContext = createContext(initialContext)

export const UserProvider = ({
  children,
  user: _user,
}: {
  children: React.ReactNode
  user: User | null
}) => {
  const [user, setUser] = useState<User | null>(_user)
  const router = useRouter()

  async function signIn(email: string, password: string) {
    const response = await fetch('/api/users/login', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })
    const json = await response.json()
    setUser(json.user ?? null)
    return user
  }

  async function signOut() {
    return signOutAction().finally(() => {
      setUser(null)
      router.push('/inloggen')
    })
  }

  return <UserContext.Provider value={{ user, signOut, signIn }}>{children}</UserContext.Provider>
}

export const useUserContext = (): UserContextType => useContext(UserContext)
